module.exports = __webpack_public_path__ + "static/media/search_image.7fd938a6.png";